import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import SectionHeader from '../ui/SectionHeader'
import TypeCard from '../common/TypeCard'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSubCategoryByCategory } from '../../features/admin/placeSlice'
import { AppDispatch, RootState } from '../../store'
import { subcategoryImages } from '../../constants/data'

const BrowseType = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch<AppDispatch>()
    const { subCategories } = useSelector((state: RootState) => state.placeSlice)
    useEffect(() => {
        dispatch(fetchSubCategoryByCategory(1))
    }, [dispatch])
    return (
        <div className=' main-prop padding-container'>
            <SectionHeader title={t("browse-by-property")} text={t("browse-by-property-text")} />
            <ul className=' grid lg:grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 gap-5 mt-8 '>
                {subCategories?.map((subCategory: any, index: number) => (
                    <li key={index} className='rounded-lg overflow-hidden bg-white'>
                        <TypeCard
                            name={subCategory?.title}
                            image={subcategoryImages[subCategory?.id] || ""}
                            id={subCategory.id}
                        />
                    </li>
                ))}
            </ul>
        </div>
    )
}
export default BrowseType